import { render } from "./AppPagination.vue?vue&type=template&id=f8aa2a8c"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__